/**
 * Navigation Service Error Handling
 * Contains error classes and error handling utilities
 */

import { NavigationErrorType } from "./Enums";

/**
 * Custom navigation error class
 */
export class NavigationError extends Error {
  constructor(
    public type: NavigationErrorType,
    message: string,
    public originalError?: Error
  ) {
    super(message);
    this.name = "NavigationError";
  }
}

/**
 * Safely handles navigation errors with logging
 */
export const handleNavigationError = (error: Error, context: string): void => {
  console.error(`Navigation error in ${context}:`, error);
};
